import React from 'react';
import SubjectCardsGrid from './components/SubjectCardsGrid';
import './App.css';

function App() {
  return (
    <div className="App">
      <SubjectCardsGrid />
    </div>
  );
}

export default App;
